import React, { useEffect, useRef, useState } from "react";
import "./Katbook.css";
import Header from "../header/Header";
import Footer from "../footer/Footer";
import LapLogo from "../../Assests_Url/PixelBook.png";
import student from "../../Assests_Url/student_kat.png";
import teacher from "../../Assests_Url/teacher_kat.png";
import img1 from "../../Assests_Url/image1.png";
import img2 from "../../Assests_Url/image2.png";
import { useLocation, useNavigate } from "react-router-dom";

const Katbook_new = ({
  RoutesClick,
  NcertClick,
  selectedLang,
  setSelectedLang,
  allCountries
}) => {
  const [registerModal, setRegisterModal] = React.useState(false);

  const location = useLocation();
  const expRef = useRef(null);

  useEffect(() => {
    if (location.state && location.state.scroll === "bottom") {
      setTimeout(() => {
        // Ensure DOM is updated
        if (expRef.current) {
          expRef.current.scrollIntoView({ behavior: "smooth" });
        }
      }, 100); // 100ms delay works well
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);

  // useEffect(() => {
  //   if (location.state?.scroll === "bottom") {
  //     window.scrollTo({
  //       top: document.body.scrollHeight,
  //       behavior: "smooth",
  //     });
  //   } else {
  //     window.scrollTo(0, 0);
  //   }
  // }, [location.state]);

  const [activeTabHeader, setActiveTabHeader] = useState("KATBOOK");
  const [studentregisterModal, setStudentRegisterModal] = useState(false);
  const [ParentregisterModal, setParentRegisterModal] = useState(false);
  const [TeacherregisterModal, setTeacherregisterModal] = useState(false);
  const [AdminregisterModal, setAdminregisterModal] = useState(false);
  const handleTabClickHeader = (tab) => {
    setActiveTabHeader(tab);
  };

  const navigate = useNavigate();

  const searchParams = new URLSearchParams(location.search);
  const lang = searchParams.get("lang") || "en";

  return (
    <div>
      <Header
        activeTab={activeTabHeader}
        handleTabClick={handleTabClickHeader}
        studentregisterModal={studentregisterModal}
        setStudentRegisterModal={setStudentRegisterModal}
        ParentregisterModal={ParentregisterModal}
        setParentRegisterModal={setParentRegisterModal}
        TeacherregisterModal={TeacherregisterModal}
        setTeacherregisterModal={setTeacherregisterModal}
        registerModal={registerModal}
        AdminregisterModal={AdminregisterModal}
        setAdminregisterModal={setAdminregisterModal}
        setRegisterModal={setRegisterModal}
        RoutesClick={RoutesClick}
        NcertClick={NcertClick}
        selectedLang={selectedLang}
        setSelectedLang={setSelectedLang}
        allCountries={allCountries}
      />
      <div className="py-5 px-4">
        <div className="d-flex flex-column gap-4 pt-5 common-padding padd-bottom">
          <div className="pt-2">
            {lang === "en" ? (
              <div className="text-font center">
                About <span className="kat-font">KATBOOK</span>
              </div>
            ) : lang === "hi" ? (
              <div className="text-font center">
                <span className="kat-font">KATBOOK</span> के बारे में
              </div>
            ) : null}
          </div>
          <div className="text-font1">
            {/* A next-generation */}
            {lang === "en"
              ? "KATBOOK is NCERT’s next-generation"
              : lang === "hi"
              ? "कैटबुक एनसीईआरटी का अगली जनरेशन का "
              : null}
            <span className="high-font">
              {/* digital textbook platform */}
              {lang === "en"
                ? "digital textbook platform, "
                : lang === "hi"
                ? "डिजिटल पाठ्यपुस्तक प्लैटफ़ॉर्म है, "
                : null}
            </span>
            {/* developed with U-Educate to transform the way India learns. It
            blends */}
            {lang === "en"
              ? "developed with UEducate to transform the way India learns. It blends "
              : lang === "hi"
              ? "जिसे भारत में सीखने के तरीके को बदलने के लिए यूएजुकेट के साथ विकसित किया गया है। यह "
              : null}
            <span className="high-font">
              {/* audio, video, 2D/3D/AR/VR models, interactive exercises,
              translation tools, smart search, personalization, and analytics */}
              {lang === "en"
                ? "audio, video, 2D/3D/AR/VR models, interactive exercises, translation tools, smart search, personalization, and analytics "
                : lang === "hi"
                ? "ऑडियो, वीडियो, 2D/3D/AR/VR मॉडल, इंटरैक्टिव अभ्यास, अनुवाद उपकरण, स्मार्ट खोज, निजीकरण और विश्लेषण "
                : null}
            </span>
            {/* into one seamless experience. */}
            {lang === "en"
              ? "into one seamless experience. "
              : lang === "hi"
              ? "को एक सहज अनुभव में मिश्रित करता है।"
              : null}
          </div>
          <div className="text-font1">
            {/* Unlike static e-books, KATBOOK offers two tailored experiences—for
            Foundation learners (Classes 1–5) and Higher Standard learners
            (Classes 6–12)—ensuring every stage of education is supported with
            the right tools. */}
            {lang === "en"
              ? "Unlike static e-books, KATBOOK offers two tailored experiences—for Foundation learners (Classes 1–5) and Higher Standard learners (Classes 6–12)—ensuring every stage of education is supported with the right tools."
              : lang === "hi"
              ? "स्थिर ई-पुस्तकों के असमान, कैटबुक दो अनुकूलित अनुभव प्रदान करता है - फाउंडेशन शिक्षार्थियों (कक्षा 1-5) और उच्च मानक शिक्षार्थियों (कक्षा 6-12) के लिए - यह सुनिश्चित करते हुए कि शिक्षा के प्रत्येक चरण को सही उपकरणों के साथ समर्थित किया जाता है।"
              : null}
          </div>
        </div>

        <div className="com-learn w-100 common-padding">
          <div className="d-flex flex-column gap-3 padd-bottom">
            <div className="compe-font center">
              {/* A Complete Digital Learning Ecosystem */}
              {lang === "en"
                ? "A Complete Digital Learning Ecosystem"
                : lang === "hi"
                ? "एक संपूर्ण डिजिटल लर्निंग इकोसिस्टम"
                : null}
            </div>
            <div className="text-font1">
              {/* KATBOOK is not just another e-book. It is a */}
              {lang === "en"
                ? "KATBOOK is not just another e-book. It is a "
                : lang === "hi"
                ? "कैटबुक सिर्फ एक और ई-बुक नहीं है। यह एक "
                : null}
              <span className="high-font">
                {/* 360° learning platform */}
                {lang === "en"
                  ? "360° learning platform "
                  : lang === "hi"
                  ? "360° लर्निंग प्लेटफ़ॉर्म "
                  : null}
              </span>
              {/* that combines textbooks, multimedia, practice tools, 
              analytics, and teacher resources into */}
              {lang === "en"
                ? "that combines textbooks, multimedia, practice tools, analytics, and teacher resources into "
                : lang === "hi"
                ? "है जो पाठ्यपुस्तकों, मल्टीमीडिया, अभ्यास उपकरणों, विश्लेषण और शिक्षक संसाधनों को "
                : null}
              <span className="high-font">
                {/* one powerful ecosystem */}
                {lang === "en"
                  ? "one powerful ecosystem."
                  : lang === "hi"
                  ? "एक शक्तिशाली इकोसिस्टम में समाहित करता है। "
                  : null}
              </span>
            </div>
          </div>

          <div className="width65">
            <img src={LapLogo} alt="Laptop-Image" width={"100%"} />
          </div>
        </div>

        <div className="d-flex flex-column justify-content-center align-items-center gap-4 pt-2 pb-4">
          <div className="compe-font">
            {/* Why KATBOOK ? */}
            {lang === "en"
              ? "Why KATBOOK ?"
              : lang === "hi"
              ? "क्यों कैटबुक ?"
              : null}
          </div>
          <div className="kat-card">
            <div className="p-3 d-flex flex-column align-items-center gap-3 box-katbook">
              <div className="box-font">
                {/* For Students */}
                {lang === "en"
                  ? "For Students"
                  : lang === "hi"
                  ? "विद्यार्थियों के लिए "
                  : null}
              </div>
              <div>
                <img src={student} alt="" width={"85%"} />
              </div>
              <div className="box-para-font text-center">
                {/* It makes learning joyful, interactive, and self-paced */}
                {lang === "en"
                  ? "It makes learning joyful, interactive, and self-paced "
                  : lang === "hi"
                  ? "यह सीखने को आनंददायक, संवादात्मक और स्व-गति आधारित बनाता है।"
                  : null}
              </div>
            </div>

            <div className="p-3 d-flex flex-column align-items-center gap-3 box-katbook">
              <div className="box-font">
                {/* For Teachers */}
                {lang === "en"
                  ? "For Teachers"
                  : lang === "hi"
                  ? "शिक्षकों के लिए "
                  : null}
              </div>
              <div>
                <img src={teacher} alt="" width={"85%"} />
              </div>
              <div className="box-para-font text-center">
                {/* It provides structured lesson support, multimedia resources, and
                analytics */}
                {lang === "en"
                  ? "It provides structured lesson support, multimedia resources, and analytics"
                  : lang === "hi"
                  ? "यह संरचित पाठ समर्थन, मल्टीमीडिया संसाधन और विश्लेषण प्रदान करता है।"
                  : null}
              </div>
            </div>

            {/* <div className="p-3 d-flex flex-column align-items-center gap-3 box-katbook">
              <div className="box-font">
                For Parents
              </div>
              <div>
                <img src={family} alt="" width={"85%"} />
              </div>
              <div className="box-para-font text-center">
                It offers transparency into
                their child’s learning journey
              </div>
            </div> */}
          </div>
        </div>

        <div className="d-flex flex-column justify-content-center align-items-center gap-4 pt-5 pb-4">
          <div className="text-font">
            {/* Every feature has been designed to: */}
            {lang === "en"
              ? "Every feature has been designed to: "
              : lang === "hi"
              ? "हर विशेषता को इस प्रकार डिज़ाइन किया गया है: "
              : null}
          </div>
          <div className="feat-col">
            <div className="d-flex flex-column align-items-center gap-3 box-feature">
              <div className="px-4 pt-4">
                <img src={img1} alt="" width={"100%"} />
              </div>
              <div className="px-4 eng-font text-center">
                <span className="eng-stu">
                  {/* Engage students{" "} */}
                  {lang === "en"
                    ? "Engage students "
                    : lang === "hi"
                    ? "विद्यार्थियों "
                    : null}
                </span>
                {/* with joyful, interactive learning */}
                {lang === "en"
                  ? "with joyful, interactive learning"
                  : lang === "hi"
                  ? "को आनंददायक, संवादात्मक शिक्षण में संलग्न करना"
                  : null}
              </div>
            </div>

            <div className="d-flex flex-column align-items-center gap-3 box-feature">
              <div className="px-4 pt-4">
                <img src={img2} alt="" width={"100%"} />
              </div>
              <div className="px-4 eng-font text-center">
                <span className="eng-stu">
                  {/* Empower teachers */}
                  {lang === "en"
                    ? "Empower teachers "
                    : lang === "hi"
                    ? "शिक्षकों को "
                    : null}
                </span>
                {/* with ready-to-use classroom tools */}
                {lang === "en"
                  ? "with ready-to-use classroom tools "
                  : lang === "hi"
                  ? "- उपयोग योग्य तैयार कक्षा उपकरणों से सक्षम बनाना"
                  : null}
              </div>
            </div>

            {/* <div className="d-flex flex-column align-items-center gap-3 box-feature">
              <div className="px-4 pt-4">
                <img src={img3} alt="" width={"100%"} />
              </div>
              <div className="px-4 eng-font text-center">
                <span className="eng-stu">Involve parents</span> with
                transparency and progress updates
              </div>
            </div> */}
          </div>
        </div>

        <div className="d-flex flex-column justify-content-center align-items-center gap-4 pt-5">
          <div className="compe-font">
            <span className="kat-font-kat center">KATBOOK</span>
            {/* Offers two tailored experiences */}
            {lang === "en"
              ? " Offers two tailored experiences "
              : lang === "hi"
              ? " दो विशेष अनुभव प्रदान करता है "
              : null}
          </div>

          <div ref={expRef} className="katbook-exp">
            <div className="py-4 d-flex flex-column align-items-center gap-4 box-katOff width40">
              <div className="for-font">
                {/* For{" "} */}
                {lang === "en" ? "For " : lang === "hi" ? "" : null}
                <span className="for-foun">
                  {/* Foundation (Classes 1–5) */}
                  {lang === "en"
                    ? "Foundation (Classes 1–5)"
                    : lang === "hi"
                    ? " फाउंडेशन (कक्षा 1–5)"
                    : null}
                </span>
              </div>
              <div className="eng-font">
                {/* Playful, Activity-Based, Inclusive Learning. */}
                {lang === "en"
                  ? "Playful, Activity-Based, Inclusive Learning. "
                  : lang === "hi"
                  ? "खेल-खेल में, गतिविधि-आधारित, समावेशी शिक्षण।"
                  : null}
              </div>
              <div className="d-flex align-items-center gap-2">
                <button
                  className="button-kat"
                  onClick={() => {
                    navigate("/katbook/uteach/foundation");
                  }}
                >
                  {/* UTeach KATBOOK &nbsp; &rarr; */}
                  {lang === "en" ? (
                    <>UTeach KATBOOK &nbsp; &rarr;</>
                  ) : lang === "hi" ? (
                    <>यूटीच KATBOOK &nbsp; &rarr;</>
                  ) : null}
                </button>

                <button
                  className="button-kat"
                  onClick={() => {
                    navigate("/katbook/ulearn/foundation");
                  }}
                >
                  {/* ULearn KATBOOK &nbsp; &rarr; */}
                  {lang === "en" ? (
                    <>ULearn KATBOOK &nbsp; &rarr;</>
                  ) : lang === "hi" ? (
                    <>यूलर्न KATBOOK &nbsp; &rarr;</>
                  ) : null}
                </button>
              </div>
            </div>

            <div className="py-4 d-flex flex-column align-items-center gap-4 box-katOff width40">
              <div className="for-font">
                {/* For{" "} */}
                {lang === "en" ? "For " : lang === "hi" ? "" : null}
                <span className="for-foun">
                  {/* Higher Standards (Classes 6–12) */}
                  {lang === "en"
                    ? "Higher Standards (Classes 6–12)"
                    : lang === "hi"
                    ? "उच्च कक्षाएँ (कक्षा 6–12)"
                    : null}
                </span>
              </div>
              <div className="eng-font">
                {/* Advanced, Subject-Focused, Exam-Ready Learning. */}
                {lang === "en"
                  ? "Advanced, Subject-Focused, Exam-Ready Learning."
                  : lang === "hi"
                  ? "उन्नत, विषय-केंद्रित, परीक्षा-उन्मुख शिक्षण।"
                  : null}
              </div>
              <div className="d-flex align-items-center gap-2">
                <button
                  className="button-kat"
                  onClick={() => {
                    navigate("/katbook/uteach/standard");
                  }}
                >
                  {/* UTeach KATBOOK &nbsp; &rarr; */}
                  {lang === "en" ? (
                    <>UTeach KATBOOK &nbsp; &rarr;</>
                  ) : lang === "hi" ? (
                    <>यूटीच KATBOOK &nbsp; &rarr;</>
                  ) : null}
                </button>

                <button
                  className="button-kat"
                  onClick={() => {
                    navigate("/katbook/ulearn/standard");
                  }}
                >
                  {/* ULearn KATBOOK &nbsp; &rarr; */}
                  {lang === "en" ? (
                    <>ULearn KATBOOK &nbsp; &rarr;</>
                  ) : lang === "hi" ? (
                    <>यूलर्न KATBOOK &nbsp; &rarr;</>
                  ) : null}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer
        setActiveTab={setActiveTabHeader}
        RoutesClick={RoutesClick}
        NcertClick={NcertClick}
        selectedLang={selectedLang}
        setSelectedLang={setSelectedLang}
      />
    </div>
  );
};

export default Katbook_new;
